import React from "react";
import Img1 from '../Fitnessimg/work-1.jpg';
import Img2 from '../Fitnessimg/work-2.jpg';
import Img3 from '../Fitnessimg/work-3.jpg';
import Img4 from '../Fitnessimg/work-4.jpg';
import Img5 from '../Fitnessimg/work-5.jpg';
import Img6 from '../Fitnessimg/work-6.jpg';
import Img7 from '../Fitnessimg/work-7.jpg';
import Img8 from '../Fitnessimg/work-8.jpg';
import Img9 from '../Fitnessimg/work-9.jpg';
import Img10 from '../Fitnessimg/work-10.jpg';
import Img11 from '../Fitnessimg/work-11.jpg';
import Img12 from '../Fitnessimg/work-12.jpg';
const Footer = () => {
    return(
        <div class="container-fluid footer py-5 wow fadeIn" data-wow-delay="0.2s">
            <div class="container py-5">
                <div class="row g-5 mb-5 align-items-center">
                    <div class="col-lg-7">
                        <div class="position-relative d-flex" style={{transform: "skew(18deg)"}}>
                            <input class="form-control border-0 w-100 py-3 pe-5" type="text" placeholder="Email address to Subscribe"/>
                            <button type="button" class="btn-primary py-2 px-4 ms-3"> <span>Subscribe</span></button>
                        </div>
                    </div>
                    <div class="col-lg-5">
                        <div class="d-flex align-items-center justify-content-center justify-content-lg-end">
                            <a class="btn btn-primary btn-md-square me-3" href=""><i class="fab fa-facebook-f"></i></a>
                            <a class="btn btn-primary btn-md-square me-3" href=""><i class="fab fa-twitter"></i></a>
                            <a class="btn btn-primary btn-md-square me-3" href=""><i class="fab fa-instagram"></i></a>
                            <a class="btn btn-primary btn-md-square me-0" href=""><i class="fab fa-linkedin-in"></i></a>
                        </div>
                    </div>
                </div>
                <div class="row g-5">
                    <div class="col-md-6 col-lg-6 col-xl-3">
                        <div class="footer-item">
                            <h4 class="text-white mb-4"><i class="fas fa-hand-rock text-primary me-2"></i> Fitness</h4>
                            <p class="mb-0">Dolor amet sit justo amet elitr clita ipsum elitr est.Lorem ipsum dolor sit amet, consectetur adipiscing elit consectetur adipiscing elit.</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6 col-xl-3">
                        <div class="footer-item">
                            <h4 class="text-white mb-4">Quick Links</h4>
                            <a href="#"> Home</a>
                            <a href="#"> About us</a>
                            <a href="#"> Our Courses</a>
                            <a href="#"> Our Features</a>
                            <a href="#"> Our Blog & news</a>
                            <a href="#"> Testimonial</a>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6 col-xl-3">
                        <div class="footer-item">
                            <h4 class="text-white mb-4"> Contact Info</h4>
                            <div class="row g-2">
                                <div class="col-12">
                                    <div class="d-flex">
                                        <i class="fas fa-map-marker-alt text-primary me-2"></i>
                                        <div>
                                            <h5 class="text-white mb-2">Address</h5>
                                            <p class="mb-0">123 street New York</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="d-flex">
                                        <i class="fas fa-envelope text-primary me-2"></i>
                                        <div>
                                            <h5 class="text-white mb-2">Mail Us</h5>
                                            <p class="mb-0">info@example.com</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="d-flex">
                                        <i class="fa fa-phone-alt text-primary me-2"></i>
                                        <div>
                                            <h5 class="text-white mb-2">Telephone</h5>
                                            <p class="mb-0">(+012) 3456 7890 123</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6 col-xl-3">
                        <div class="footer-item">
                            <h4 class="text-white mb-4">Recent Work</h4>
                            <div class="row g-2">
                                <div class="col-3">
                                    <div class="footer-item-img">
                                        <a href="#"><img src={Img9} class="img-fluid" alt=""/></a>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="footer-item-img">
                                        <a href="#"><img src={Img10} class="img-fluid" alt=""/></a>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="footer-item-img">
                                        <a href="#"><img src={Img11} class="img-fluid" alt=""/></a>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="footer-item-img">
                                        <a href="#"><img src={Img12} class="img-fluid" alt=""/></a>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="footer-item-img">
                                        <a href="#"><img src={Img1} class="img-fluid" alt=""/></a>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="footer-item-img">
                                        <a href="#"><img src={Img2} class="img-fluid" alt=""/></a>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="footer-item-img">
                                        <a href="#"><img src={Img3} class="img-fluid" alt=""/></a>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="footer-item-img">
                                        <a href="#"><img src={Img4} class="img-fluid" alt=""/></a>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="footer-item-img">
                                        <a href="#"><img src={Img5} class="img-fluid" alt=""/></a>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="footer-item-img">
                                        <a href="#"><img src={Img6} class="img-fluid" alt=""/></a>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="footer-item-img">
                                        <a href="#"><img src={Img7} class="img-fluid" alt=""/></a>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="footer-item-img">
                                        <a href="#"><img src={Img8} class="img-fluid" alt=""/></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Footer;